import { CSSProperties } from 'react';

type BarProps = {
  percentage: number;
  divisions?: {
    risk?: number;
    over?: number;
  };
  color?: string;
};

export const Bar = (props: BarProps) => {
  const { percentage, divisions, color } = props;

  let derivedColor = 'bg-button-primary-hover';
  if (percentage >= 100) {
    derivedColor = 'bg-button-warning-default';
  } else if (percentage >= 80) {
    derivedColor = 'bg-orange-200';
  }

  if (color) {
    derivedColor = color;
  }

  return (
    <div className="w-full h-[10px] bg-gray-300 rounded-full overflow-hidden">
      <div
        className={`h-full ${derivedColor} w-[var(--percentage)] rounded-full`}
        style={
          {
            '--percentage': `${percentage}%`,
          } as CSSProperties
        }
      >
        {divisions ? (
          <div className="flex h-full w-full rounded-full overflow-hidden">
            <div className="bg-button-primary-hover grow" />
            <div
              className="w-[var(--percentage)] bg-orange-200"
              style={
                {
                  '--percentage': `${divisions.risk}%`,
                } as CSSProperties
              }
            />
            <div
              className="w-[var(--percentage)] bg-button-warning-default"
              style={
                {
                  '--percentage': `${divisions.over}%`,
                } as CSSProperties
              }
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
